import { alias } from '@ember/object/computed';
import { attr } from '@ember-data/model';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';

// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-param-reassign */
export default EmberDataBaseModel.extend({
  isoCode: attr('string'),
  kanji: attr('string'),
  kana: attr('string'),
  subareas: fragmentArray('jp-city'),
  cities: alias('subareas'),
  type: attr('string'),
  load(id, data) {
    // Convert ISO code values like 'JP-26' to '26'
    data.iso_code = data.iso_code.replace('JP-', '');
    return this._super(id, data);
  }
}).reopenClass({
  _modelNameForMigration: 'jp-state'
});